<template>
  <!--
    The accelerated-demo hint (card `t_803e86a4`): one line, under the top bar,
    so nobody wonders why the day runs fast. Dismissible once per device — a
    guest who has read the sentence has read it — and it renders only where the
    guest chrome does (`useDemoGuest`).
  -->
  <div
    v-if="visible"
    data-demo-hint-strip
    class="flex items-center gap-2 border-t border-amber-200 bg-amber-50 px-4 py-1.5 text-xs text-amber-900 dark:border-amber-900/50 dark:bg-amber-900/20 dark:text-amber-200"
  >
    <span class="material-symbols-outlined flex-shrink-0 text-base leading-none">speed</span>
    <!-- One line where there is room for one (`sm:truncate`); on a phone the
         sentence wraps rather than losing its end to an ellipsis. -->
    <p class="min-w-0 flex-1 leading-snug sm:truncate">{{ t('views.demoGuest.hint') }}</p>
    <button
      type="button"
      class="flex-shrink-0 rounded-md p-0.5 transition-colors hover:bg-amber-100 dark:hover:bg-amber-900/40"
      :title="t('views.demoGuest.dismiss')"
      :aria-label="t('views.demoGuest.dismiss')"
      @click="dismiss">
      <span class="material-symbols-outlined text-base leading-none">close</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDemoGuest } from '../../composables/useDemoGuest';
import { readDemoHintDismissed, writeDemoHintDismissed } from '../../utils/demoGuest';

const { t } = useI18n();
const { isGuest } = useDemoGuest();

// Read once at mount: the strip is a line a person has either already closed on
// this device or has not, and nothing else writes the flag.
const dismissed = ref(readDemoHintDismissed());

const visible = computed(() => isGuest.value && !dismissed.value);

/** Close it for this device. A storage that refuses the write just closes it here. */
function dismiss(): void {
  dismissed.value = true;
  writeDemoHintDismissed();
}
</script>
